<section>
  <h3>{{mode}}</h3>
  <kendo-tabstrip>

    <kendo-tabstrip-tab [selected]="true" title="Item Master">
      <ng-template kendoTabContent>
        <section>
          <form name="itemMaster" autocomplete="off" novalidate>
            <div class="row">
              <div class="col-sm-12 col-md-12 headerText  badge badge-secondary">
                <h4>Item Master</h4>
              </div>
              <br />
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="input-wrappers">
                    <label class="lblCls">
                      {{item?.itemMaster?.itemNumber?.label}}<span class="requiredField">*</span>
                    </label>
                    <kendo-textbox  id="additemtextbox"  name="itemNumber" [(ngModel)]="item.itemMaster.itemNumber.value" (blur)="createLongItemNumber(); validateAddItemForm();"
                                   (valueChange)="finishSelected($event)"
                                   [ngClass]="{'borderRed':!item.itemMaster.itemNumber.valid }"></kendo-textbox>
                    </div>
                  </div>
                <div class="form-group">       
                    <label class="lblCls">
                      {{item?.itemMaster?.finish?.label}}
                    </label>
                    <kendo-dropdownlist  style=" height: 25px; margin-left: 15px; margin-top: 4px;width:92.8%" name="finish" [(ngModel)]="item.itemMaster.finish.value"
                                        [data]="itemFinishes"
                                        textField="name" valueField="value" (blur)="createLongItemNumber()">
                    </kendo-dropdownlist>         
                    <!--<kendo-textbox class="form-control" name="finish" [(ngModel)]="item.itemMaster.finish.value" (blur)="createLongItemNumber()"></kendo-textbox>-->
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{item?.itemMaster?.sellingUnitofMeasure?.label}}
                    </label>
                    <kendo-dropdownlist style=" height: 25px; margin-left: 15px; margin-top: 4px;width:92.8%" name="sellingUnitofMeasure" [(ngModel)]="item.itemMaster.sellingUnitofMeasure.value"
                                        [data]="item.itemMaster.sellingUnitofMeasure.data"
                                        textField="key" valueField="value">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <div class="input-wrapper">
                      <label class="lblCls">
                        {{item?.itemMaster?.basePrice?.label}}<span class="requiredField">*</span>
                      </label>
                      <kendo-numerictextbox id="baseprice" [format]="'n2'" name="basePrice" [(ngModel)]="item.itemMaster.basePrice.value"
                                            (blur)="validateAddItemForm();" [ngClass]="{'borderRed':!item.itemMaster.basePrice.valid }"></kendo-numerictextbox>

                      <span class="k-icon k-font-icon k-i-lock" (click)="setBasePriceLock(false)" *ngIf="item.itemMaster.isExcludeBasePriceFromUpdate.value"></span>
                      <span class="k-icon k-font-icon k-i-unlock" (click)="setBasePriceLock(true)" *ngIf="!item.itemMaster.isExcludeBasePriceFromUpdate.value"></span>
                    </div>
                    </div>
                    <div class="form-group ">
                      <label class="mr-2">
                        {{item?.itemMaster?.canBeOrderedOnline?.label}}
                      </label>
                      <kendo-switch name="canBeOrderedOnline" [(ngModel)]="item.itemMaster.canBeOrderedOnline.value" [onLabel]="'Yes'" [offLabel]="'No'">
                      </kendo-switch>
                    </div>
                    <div class="form-group ">
                      <label class="mr-2">
                        {{item?.itemMaster?.isActive?.label}}
                      </label>
                      <kendo-switch name="isActive" [(ngModel)]="item.itemMaster.isActive.value" [onLabel]="'Yes'" [offLabel]="'No'">
                      </kendo-switch>
                    </div>
                    <!--
  <div class="form-group">
    <label class="">
      {{item?.itemMaster?.minimumQuantityToOrder?.label}}
    </label>
    <kendo-textbox class="form-control" name="minimumQuantityToOrder" [(ngModel)]="item.itemMaster.minimumQuantityToOrder.value"></kendo-textbox>
  </div>-->
                    <!--<div class="form-group ">
    <label class="mr-2">
      {{item?.itemMaster?.isExcludeDescriptionFromUpdate?.label}}
    </label>
    <kendo-switch name="isExcludeDescriptionFromUpdate" [(ngModel)]="item.itemMaster.isExcludeDescriptionFromUpdate.value" [onLabel]="'Yes'" [offLabel]="'No'" [disabled]="isExcludeDescriptionFromUpdate_disable">
    </kendo-switch>
  </div>
  <div class="form-group ">
    <label class="mr-2">
      {{item?.itemMaster?.isExcludeBasePriceFromUpdate?.label}}
    </label>
    <kendo-switch name="isExcludeBasePriceFromUpdate" [(ngModel)]="item.itemMaster.isExcludeBasePriceFromUpdate.value" [onLabel]="'Yes'" [offLabel]="'No'" [disabled]="isExcludeBasePriceFromUpdate_disable">
    </kendo-switch>
  </div>-->
                    <div class="form-group ">
                      <label class="mr-2">
                        {{item?.itemMaster?.manuallyAddedDonotTouch?.label}}
                      </label>
                      <kendo-switch name="manuallyAddedDonotTouch" [(ngModel)]="item.itemMaster.manuallyAddedDonotTouch.value" [onLabel]="'Yes'" [offLabel]="'No'" (valueChange)="onChangemanuallyAddedDonotTouch($event)">
                      </kendo-switch>
                    </div>
                    <div class="form-group">
                      <label class="lblCls">
                        {{item?.itemMaster?.countryCode?.label}}
                      </label>
                      <kendo-dropdownlist class="kendoInput" name="countryCode"
                                          [data]="getCountrys"
                                          [(ngModel)]="item.itemMaster.countryCode.value"
                                          [textField]="'countryCode'"
                                          [valueField]="'countryCode'"
                                          [valuePrimitive]="true">
                      </kendo-dropdownlist>
                    </div>

                  </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="input-wrappers">
                    <label class="lblCls">
                      {{item?.itemMaster?.longItemNumber?.label}}
                    </label>
                    <kendo-textbox class="k-input" id="additemtextbox" name="longItemNumber" [(ngModel)]="item.itemMaster.longItemNumber.value" [disabled]="true"></kendo-textbox>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-wrappers">
                      <label class="lblCls">
                        {{item?.itemMaster?.size?.label}}
                      </label>
                      <kendo-textbox class="add-item-sizecls" style="width: 100px;margin-right:5px; margin-left:5px;" name="size" [(ngModel)]="item.itemMaster.size.value" (blur)="createLongItemNumber()"
                                     [disabled]="item.itemMaster.size.disabled"></kendo-textbox>
                      <label class="lblCls add-item-weightlblcls">
                        {{item?.itemMaster?.weight?.label}}
                      </label>
                      <kendo-textbox class=" add-item-sizecls" style="width: 100px;margin-right:5px; margin-left:5px;" name="weight" [(ngModel)]="item.itemMaster.weight.value"></kendo-textbox>
                      <span class="k-icon k-font-icon k-i-lock" (click)="setWeightLock(false)" *ngIf="item.itemMaster.isExcludeWeightFromUpdate.value"></span>
                      <span class="k-icon k-font-icon k-i-unlock" (click)="setWeightLock(true)" *ngIf="!item.itemMaster.isExcludeWeightFromUpdate.value"></span>
                      <label class="lblCls add-item-weightlblcls">
                        {{item?.itemMaster?.psc?.label}}
                      </label>
                      <kendo-textbox class="add-item-sizecls" style="width: 100px; margin-right: 5px; margin-left: 5px; " name="psc" [(ngModel)]="item.itemMaster.psc.value"></kendo-textbox>
                      <span class="k-icon k-font-icon k-i-lock" (click)="setPSCLock(false)" *ngIf="item.itemMaster.isExcludePSCFromUpdate.value"></span>
                      <span class="k-icon k-font-icon k-i-unlock" (click)="setPSCLock(true)" *ngIf="!item.itemMaster.isExcludePSCFromUpdate.value"></span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="lblCls">
                      {{item?.itemMaster?.category?.label}}
                    </label>
                    <kendo-dropdownlist  name="Category" style=" height: 25px; margin-left: 15px; margin-top: 4px;width:90%" [(ngModel)]="item.itemMaster.category.value"
                                        [data]="priceBookCategories"
                                        textField="name" valueField="value">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lblCls" [for]="effectiveFromLBL">
                      {{item?.itemMaster?.effectiveFrom?.label}}
                    </label>
                    <kendo-datepicker class="kendoInput" name="effectiveFrom"
                                      placeholder="MM/DD/YYYY"
                                      #effectiveFromLBL format="MM/dd/yyyy"
                                      [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                                      [(ngModel)]="item.itemMaster.effectiveFrom.value">
                    </kendo-datepicker>
                  </div>
                  <div class="form-group">
                    <label class="lblCls" [for]="effectiveToLBL">
                      {{item?.itemMaster?.effectiveTo?.label}}
                    </label>
                    <kendo-datepicker class="kendoInput" name="effectiveTo"
                                      placeholder="MM/DD/YYYY"
                                      #effectiveToLBL format="MM/dd/yyyy"
                                      [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                                      [(ngModel)]="item.itemMaster.effectiveTo.value">
                    </kendo-datepicker>
                  </div>
                  <div class="form-group">
                    <label class="lblCls" [for]="AssociatedCategory">
                      {{item?.itemMaster?.associatedCategory?.label}}
                    </label>
                    <kendo-multiselect class="kendoInput" name="AssociatedCategory" [(ngModel)]="item.itemMaster.associatedCategory.value"
                                       [data]="associatedCategories" textField="name" valueField="value">
                      <ng-template kendoMultiSelectItemTemplate let-dataList>
                        <span class="template">{{dataList.name}}</span>
                      </ng-template>
                    </kendo-multiselect>
                  </div>
                  <div class="form-group">
                    <label class="lblCls" [for]="AdminNote">
                      {{item?.itemMaster?.adminNote?.label}}
                    </label>
                    <kendo-textarea class="kendoInput" name="adminNote" (keyup)="commenttxtArea($event)"
                                    [(ngModel)]="item.itemMaster.adminNote.value" [maxlength]="maxChars"></kendo-textarea>
                    <div class="LeftCls"> {{item.itemMaster.adminNote.characterRemainingLbl}}: {{commentslength}}/{{maxChars}}</div>
                    <!--  <kendo-textarea class="kendoInput" [maxlength]="maxChars"
    [(ngModel)]="item.itemMaster.adminNote.value"></kendo-textarea>-->
                  </div>
                </div>
              <!--[min]="bidMinDate" [ngClass]="{'borderRed':requestQuoteControls.isInvalidBidDate && requestQuoteControls.isSubmitted}"
              (blur)="validateRequestQuoteForm()"-->
            </div>
          </form>
        </section>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab title="Descriptions">
      <ng-template kendoTabContent>
        <section>
          <form name="descriptions" autocomplete="off" novalidate>
            <div class="row">
              <div class="col-sm-12 col-md-12 headerText  badge badge-secondary">
                <h4>Descriptions</h4>
              </div>
              <br />
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">

                <div class="form-group">

                  <label class="">
                    {{item?.descriptions?.shortDescription?.label}}
                  </label>         
                    <kendo-textbox style="width:32%" name="shortDescription" [(ngModel)]="item.descriptions.shortDescription.value" (blur)="createLongDesc()"></kendo-textbox>
                    <span class="k-icon k-font-icon k-i-lock" (click)="setShortDescriptionLock(false)" *ngIf="item.itemMaster.isExcludeDescriptionFromUpdate.value"></span>
                    <span class="k-icon k-font-icon k-i-unlock" (click)="setShortDescriptionLock(true)" *ngIf="!item.itemMaster.isExcludeDescriptionFromUpdate.value"></span>
                 
                </div>

                <div class="form-group">
                  <label class="">
                    {{item?.descriptions?.description1?.label}}
                  </label>
                  <kendo-textbox style="width:32%" name="description1"
                                 [(ngModel)]="item.descriptions.description1.value"></kendo-textbox>
                </div>

              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label class="">
                    {{item?.descriptions?.longDescription?.label}}
                  </label>
                  <kendo-textbox style="width:32%" name="longDescription" [(ngModel)]="item.descriptions.longDescription.value" [disabled]="true"></kendo-textbox>
                </div>
                <div class="form-group">
                  <label class="">
                    {{item?.descriptions?.description2?.label}}
                  </label>
                  <kendo-textbox style="width:32%" name="description2" [(ngModel)]="item.descriptions.description2.value"></kendo-textbox>
                </div>
              </div>
            </div>
          </form>
        </section>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab title="Images">
      <ng-template kendoTabContent>
        <section>
          <form name="images" autocomplete="off" novalidate>
            <div class="row">
              <div class="col-sm-12 col-md-12 headerText  badge badge-secondary">
                <h4>Images</h4>
              </div>
              <br />
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label class="">
                    {{item?.images?.thumbnailPicture?.label}}
                  </label>
                  <kendo-textbox class="form-control" name="thumbnailPicture" [(ngModel)]="item.images.thumbnailPicture.value"></kendo-textbox>
                </div>
                <div class="form-group">
                  <label class="">
                    {{item?.images?.additionalImages?.label}}
                  </label>
                  <kendo-textbox class="form-control" name="additionalImages" [(ngModel)]="item.images.additionalImages.value"></kendo-textbox>
                </div>

              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label class="">
                    {{item?.images?.actualPicture?.label}}
                  </label>
                  <kendo-textbox class="form-control" name="actualPicture" [(ngModel)]="item.images.actualPicture.value"></kendo-textbox>
                </div>
              </div>
            </div>
          </form>
        </section>
      </ng-template>
    </kendo-tabstrip-tab>



  </kendo-tabstrip>
  <div>
    <div class="row ">
      <div class="col-sm-12 ">
        <div class="center">
          <div class="btn-group " role="group">
            <button kendoButton [disabled]="false" class=" m-3 btn k-button "
                    (click)="cancel()">
              Cancel
            </button>
            <button kendoButton [disabled]="false" class=" m-3 btn btn-success"
                    (click)="addItem()">
              {{saveButtonText}}<kendo-loader *ngIf="false" style="color:blue"></kendo-loader>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
